// Lowest-scoring evaluated calls — the quality drill-down. Clicking a row
// opens the existing CallDrawer (which lazily shows the rubric section).

import type { ScoredCall } from "../../services/evals";
import { formatDateTime, formatDurationMs } from "../analytics/format";
import { ModeChip } from "../analytics/bits";
import { scoreTone } from "./RubricSummary";

function worstCriterion(sc: ScoredCall): string | null {
  // Non-applicable criteria are stored with score 0.0 — without this filter
  // they'd always win the ascending sort on clean conversation-only calls.
  const criteria = sc.evaluation.criteria.filter((c) => c.applicable !== false);
  if (!criteria.length) return null;
  const worst = [...criteria].sort((a, b) => a.score - b.score)[0];
  return worst.score < 0.99 ? worst.key.replaceAll("_", " ") : null;
}

export function WorstCalls({
  items,
  onOpen,
}: {
  items: ScoredCall[];
  onOpen: (callId: string) => void;
}) {
  if (items.length === 0) {
    return <div className="state-box">No scored calls in this range.</div>;
  }
  return (
    <div className="recent-calls">
      {items.map((sc) => {
        const dragging = worstCriterion(sc);
        return (
          <button key={sc.call.id} className="recent-call" onClick={() => onOpen(sc.call.id)}>
            <span className={`rubric-score sm ${scoreTone(sc.evaluation.overallScore)}`}>
              {sc.evaluation.overallScore === null
                ? "—"
                : `${Math.round(sc.evaluation.overallScore * 100)}%`}
            </span>
            <span className="recent-call-main">
              <span className="recent-call-guide">
                {sc.call.guideName || sc.call.guideId}
                {sc.call.guideVersion ? ` · v${sc.call.guideVersion}` : ""}
                {dragging ? <span className="worst-criterion"> — low: {dragging}</span> : null}
              </span>
              <span className="recent-call-meta">
                {formatDateTime(sc.call.startedAt)} · {formatDurationMs(sc.call.durationMs)}
                {sc.call.callSummary ? ` · ${sc.call.callSummary}` : ""}
              </span>
            </span>
            <ModeChip call={sc.call} />
          </button>
        );
      })}
    </div>
  );
}
